import {call, put, takeEvery, select} from 'redux-saga/effects';

import AttestationsService from '../../services/attestation';
import {Actions, ACTION_TYPES} from './types';
import {Attestation, LastSubmission} from '../../common/attestsation';
export function* getAttestations(action: Actions): Object {
    try {
        const result: Attestation[] = yield call(
            AttestationsService.getAttestations.bind(AttestationsService),
            'my'
        )
       yield put({
            type: ACTION_TYPES.GET_ATTESTATIONS_SUCCESS,
            payload: result,
       })
    } catch (error) {
        console.log(error);
    }
}

export function* getAttestationSubmission(action: Actions): Object {
    try {
        const id = action.payload;
        const result: LastSubmission = yield call(
            AttestationsService.getAttestationsSubmission.bind(AttestationsService),
            id,
        )
        yield put({
                type: ACTION_TYPES.GET_ATTESTATION_SUBMISSION_SUCCESS,
                payload: {attestationId: id, lastSubmission: result},
        })
    } catch(error) {
        console.log(error);
    }
};

export function* sendAttestationResults(action: Actions): Object {
    try {
        const {attestationId, answers} = action.payload;
        const result: LastSubmission = yield call(
            AttestationsService.submitAttestation.bind(AttestationsService),
            attestationId,
            //@ts-expect-error
            answers.map(answer => ({...answer, testId: attestationId})),
        )
       yield put({
            type: ACTION_TYPES.GET_ATTESTATION_SUBMISSION_SUCCESS,
            payload: {attestationId: attestationId, lastSubmission: result},
       })
    } catch(error) {
        console.log(error);
    } 
};

export function* getAttestationStatistic(action: Actions): Object {
    try {
        const allias = action.payload || 'my';
        const result = yield call(
            AttestationsService.getStatistic.bind(AttestationsService),
            allias,
        )
        //@ts-expect-error
        result.attestations.forEach(attestation => {
            //@ts-expect-error
            attestation.users.sort((a, b) => {
                if (a.name > b.name) {
                    return 1;
                }
                return - 1;
            })
        })
        yield put({
            type: ACTION_TYPES.GET_ATTESTATION_STATISTIC_SUCESS,
            payload: result.attestations,
       })
    } catch(err) {
        console.log(err);
    }
}

const attestationSaga = [
    takeEvery(ACTION_TYPES.GET_ATTESTATIONS, getAttestations),
    takeEvery(ACTION_TYPES.GET_ATTESTATION_SUBMISSION, getAttestationSubmission),
    takeEvery(ACTION_TYPES.SEND_ATTESTATION_RESULTS, sendAttestationResults),
    takeEvery(ACTION_TYPES.GET_ATTESTATION_STATISTIC, getAttestationStatistic),
];

export default attestationSaga;